<template>
  <div class="jobsAdd">
    <el-page-header @back="$router.go(-1)" :content="id?'编辑工厂':'添加工厂'" style="margin-top: -20px; margin-left: 20px;">
    </el-page-header>
    <div class="ruleForm">
      <el-form :model="basic" :rules="rules" ref="basic" label-width="140px" class="demo-ruleForm">

        <el-form-item label="合同工厂" prop="cooperate_companyname">
          <el-col :span="24">
            <el-input v-model="basic.cooperate_companyname" placeholder="签订合同的工厂"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="合同工厂英文代码" prop="cooperate_company_enname">
          <el-col :span="24">
            <el-input editable v-model="basic.cooperate_company_enname"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="招聘工厂(简称)" prop="companyname">
          <el-col :span="24">
            <el-input v-model="basic.companyname" placeholder="实际招聘的工厂"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="招聘工厂全称">
          <el-col :span="24">
            <el-input editable v-model="basic.companyfullname"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="英文代码" prop="Enname">
          <el-col :span="24">
            <el-input editable v-model="basic.Enname"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-col :span="24">
            <el-input editable v-model="basic.email"></el-input>
          </el-col>
        </el-form-item>

   <!--     <el-form-item label="负责人电话" prop="telephone">
          <el-col :span="24">
            <el-input editable v-model="basic.telephone"></el-input>
          </el-col>
        </el-form-item> -->

        <el-form-item label="地址" prop="address">
          <el-col :span="24">
            <el-input editable v-model="basic.address"></el-input>
          </el-col>
        </el-form-item>



        <el-form-item label="驻厂" prop="adminid">
          <el-col :span="8">
            <el-select v-model="basic.adminid" placeholder="请选择驻厂" @change="getUtypeid">
              <el-option label="无" value=""></el-option>
              <el-option v-for="(item,index) in adminid" :key="index" :label="item.oausername" :value="item.uid"></el-option>
            </el-select>
          </el-col>
          <template v-if="basic.adminid">
            <el-col :span="8"><div style="text-align: right;">同步设置驻厂为借支审批人：</div></el-col>
            <el-col :span="8">

              <el-radio v-model="basic.is_setBorrowCheck" label="1">是</el-radio>
              <el-radio v-model="basic.is_setBorrowCheck" label="0">否</el-radio>
            </el-col>
          </template>

        </el-form-item>

        <el-form-item label="订单类型">
            <el-select v-model="basic.businesstype" placeholder="请选择订单类型">
              <el-option label="一手单" value="1"></el-option>
              <el-option label="二手单" value="2"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="负责人姓名">
            <el-input editable v-model="basic.leader_name"></el-input>
        </el-form-item>

        <el-form-item label="负责人电话" prop="telephone">
            <el-input editable v-model="basic.telephone"></el-input>
        </el-form-item>

        <el-form-item label="备注">
            <el-input editable v-model="basic.remark"></el-input>
        </el-form-item>

        <el-form-item label="公司LOGO">
          <!-- <el-form-item label="公司LOGO" prop="logo"> -->
          <el-col :span="24">
            <el-upload class="avatar-uploader" :action="baseURL + 'oasystem/uploadimg'" :headers="myHeaders"
              :on-success="handleLogoSuccess" name='logo'>
              <img v-if="basic.logo" :src="basic.logo" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-col>
        </el-form-item>

        <el-form-item label="公司规模">
          <!-- <el-form-item label="公司规模" prop="scale"> -->
          <el-select v-model="basic.scale_cn" placeholder="请选择公司规模" @change='selectScale'>
            <el-option v-for="(item,index) in scaleList" :key="index" :label="item.name" :value="[item.id,item.name]"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所在行业">
        <!-- <el-form-item label="所在行业" prop="trade"> -->
          <el-cascader v-model="basic.trade" ref="cascaderRef" :options="tradeList" @change="changeTrade"
           :props="{ expandTrigger: 'hover', value: 'id', label: 'categoryname', children: 'data',}"></el-cascader>
        </el-form-item>
        <el-form-item label="企业类别">
          <el-select v-model="basic.nature_cn" placeholder="请选择企业类别" @change='selectCompanyType'>
            <el-option v-for="(item,index) in companyTypeList" :key="index" :label="item.name" :value="[item.id,item.name]"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工厂简介">
          <!-- <el-form-item label="工厂简介"  prop="content"> -->
          <el-input class='textAreaClass' type="textarea" placeholder="请输入内容" v-model="basic.content"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('basic')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {
    Message
  } from "element-ui";
  export default {
    data() {
      // 手机号验证
      var checkPhone = (rule, value, callback) => {
        const phoneReg = /^([1]\d{10}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/;
        setTimeout(() => {
          if (!Number.isInteger(+value)) {
            callback(new Error("请输入数字值"));
          } else {
            if (phoneReg.test(value)) {
              callback();
            } else {
              callback(new Error("电话号码格式不正确"));
            }
          }
        }, 100);
      };

      return {
        adminid: {},
        rules: {
          cooperate_companyname:[{
            required: true,
            message: "请输入合同工厂",
            trigger: "blur",
          }, ],
          cooperate_company_enname: [{
            required: true,
            message: "请输入合同工厂英文代码",
            trigger: "blur",
          }],
          
          companyname: [{
            required: true,
            message: "请输入工厂简称",
            trigger: "blur",
          }, ],
          email: [{
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          }, ],
          telephone: [{
            required: true,
            validator: checkPhone,
            trigger: "blur",
          }, ],
          address: [{
            required: true,
            message: "请输入地址",
            trigger: "blur",
          }, ],
          Enname: [{
            required: true,
            message: "请输入英文代码",
            trigger: "blur",
          }],
          scale: [{
            required: true,
            message: "请选择公司规模",
            trigger: "change",
          }],
          trade: [{
            required: true,
            message: "请选择所在行业",
            trigger: "change",
          }],
          content: [{
            required: true,
            message: "请输入工厂简介",
            trigger: "blur",
          }],
          logo:[{
            required: true,
            message: "请上传logo",
            trigger: "blur",
          }]
        },
        optionList: [],
        current: {},
        basic: {
          cooperate_companyname:"",//合同工厂
          companyname: "",
          address: "",
          email: "",
          telephone: "",
          adminid: "",
          is_setBorrowCheck: "1",
          companyfullname: '',
          Enname: '',
          logo: '',
          trade:[],
          scale:'',
          content:'',
          nature:"",//企业类别
          nature_cn:""
        },
        focusVal: 0,
        myHeaders: {},
        id: "",
        scaleList: [],//公司规模
        tradeList: [],//行业
        companyTypeList:[],//类型
      };

    },
    mounted() {
      let token = this.$store.state.token;
      let token_type = this.$store.state.token_type;
      this.myHeaders = {
        authorization: token_type + " " + token,
      };
      this.getCategory()
    },
    activated() {
      this.id = this.$route.query.id;
      if (this.id) {
        this.getData();
      }

      //驻厂选择
      this.gets("oasystem/cateadminlist").then((res) => {
        this.adminid = res.data.data
        this.adminid.map((item)=>{
          item.uid = item.uid + ''
          return item
        })
      });

    },
    methods: {
      getData() {
        //角色详情信息
        this.gets(
          "oasystem/companyinfo?id=" +
          this.id
        ).then((res) => {
          this.id = res.data.data.id
          this.basic = res.data.data;
          this.basic.adminid = res.data.data.adminid + ''
          this.basic.businesstype = res.data.data.businesstype + ''
          this.basic.is_setBorrowCheck = res.data.data.is_setBorrowCheck + ''
        });
      },

      getUtypeid(e){
        if(e){
          this.adminid.map((item)=>{
            if(item.uid == e){
              this.basic.utypeid = item.id
            }
          })
        }else{
          this.basic.utypeid = ''
        }
      },

      changeTrade(){
        this.basic.trade_cn  = this.$refs["cascaderRef"].getCheckedNodes()[0].pathLabels
      },

      selectScale(val){
        this.basic.scale_cn = val[1]
        this.basic.scale = val[0]
      },
      selectCompanyType(val) {
        this.basic.nature_cn = val[1]
        this.basic.nature = val[0]
      },

      getCategory() {
        this.gets('category/indexpz').then(res => {
          let list = res.data.data
          this.scaleList = list.scale
          this.tradeList = list.newtrade;
          let companyTypeList = [];//公司类型
          for (const key in list.company_type) {
            let item = { id: key, name: list.company_type[key] };
            companyTypeList.push(item);
          }
          this.companyTypeList = companyTypeList;
        })
      },

      handleLogoSuccess(res, flie) {
        this.basic.logo = res.data.img
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.basic.id = this.id
            this.post(this.id?"oasystem/editcompany":"oasystem/addcompany", this.basic)
              .then((res) => {
                if (res.data.code == 1) {
                  Message.success(res.data.msg);
                  this.$router.go(-1);
                } else {
                 return Message.warning(res.data.msg);
                }
              })
              .catch((err) => {
                Message.error(err.data.message);
              });
          } else {
            return false;
          }
        });
      },
      // getoatype(val){
      //   console.log(val)
      // }
      // checkNumber(){
      //   let mobile = this.basic.mobile
      //   this.gets('oasystem/is_reg',{mobile}).then(res=>{
      //     if(res.data.code == 0){Message.warning(res.data.msg)}
      //     else{Message.success(res.data.msg)}
      //   })
      // },
    },
  };
</script>

<style scoped>
  .avatar-uploader>>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .textAreaClass >>> textarea{
    width: 100%;
    height: 300px;
    resize: none;
  }
</style>



// WEBPACK FOOTER //
// src/view/jobsManage/oacompanyEdit.vue